// Product data structure based on SHIVAY STONEX folder structure
export interface Product {
  id: string;
  name: string;
  productImage: string;
  usageImage: string;
  description: string;
  origin: string;
  rating: number;
  features: string[];
  category: string;
}

// Map folder names to their usage image filenames
const usageImageMap: { [key: string]: string } = {
  'Absolute Black Granite': 'ABG.png',
  'Alaska Gold': 'AG.png',
  'Alaska Red': 'AR.png',
  'Albeta White': 'AW.png',
  'Amazon Granite': 'AG.png',
  'Astrus Brown': 'Picture.png', // Note: This folder has Picture.png instead of Product.png
  'Black Emberador': 'BE.png',
  'Black Galaxy Granite': 'BGG.png',
  'Black Markino': 'BM.png',
  'Black Marquina Granite': 'BMG.png',
  'Black Pearl': 'BP.png',
  'Black Valley': 'BV.png',
  'Blue Flamingo': 'BF.png',
  'Blue Peral': 'BP.png',
  'Blue Roots': 'BR.png',
  'Calculta Quartz': 'CQ.png',
  'Coin Black Granite': 'CBG.png',
  'Copper Dune': 'CD.png',
  'Deset Eagle': 'DE.png',
  'Dessert Green': 'DG.png',
  'Dyna Itanlian': 'DI.png',
  'Fish Black': 'FB.png',
  'Gaya Green': 'GG.png',
  'Green Katini Marble': 'GKM.png',
  'Ice Water Granite': 'IWG.png',
  'Ijen Blue': 'IB.png',
  'Imperial Gold': 'IG.png',
  'Imperial Red': 'IR.png',
  'Labradorite': 'Labradorite.png',
  'Majistic Lappato Granite': 'MLG.png',
  'Nickel White': 'NW.png',
  'Rainforest Marble': 'RM.png',
  'Roma Imperiale': 'RI.png',
  'Rose Titanium': 'RT.png',
  'Taj Mahal': 'TM.png',
  'Temptation Blue': 'TB.png',
  'Tiger Skin Granite': 'TSG.png',
  'Verde Lapponia': 'VL.png', // Note: This folder has Prooduct.png (typo) instead of Product.png
  'Volga Blue': 'VB.png',
  'White Carrara': 'WC.png',
  'White Granite': 'WG.png',
};

// Product names list
const productNames = Object.keys(usageImageMap);

// Helper function to convert product name to kebab-case folder name
const toKebabCase = (str: string): string => {
  return str.toLowerCase().replace(/\s+/g, '-');
};

// Generate products data
export const getProducts = (): Product[] => {
  return productNames.map((name, index) => {
    // Handle special cases for product image filename
    let productImageFile = 'Product.png';
    if (name === 'Astrus Brown') {
      productImageFile = 'Picture.png';
    } else if (name === 'Verde Lapponia') {
      productImageFile = 'Prooduct.png'; // Note: typo in actual filename
    }
    
    // Build paths with kebab-case folder names - images are now in /images/products folder
    const folderName = toKebabCase(name);
    const basePath = `/images/products/${folderName}`;
    const productImagePath = `${basePath}/${productImageFile}`;
    const usageImagePath = `${basePath}/${usageImageMap[name]}`;
    
    // Determine category based on name
    let category = 'Marble';
    if (name.toLowerCase().includes('granite')) {
      category = 'Granite';
    } else if (name.toLowerCase().includes('quartz')) {
      category = 'Quartz';
    }
    
    // Determine origin
    let origin = 'India';
    if (name.toLowerCase().includes('italian') || name.toLowerCase().includes('carrara') || name.toLowerCase().includes('roma imperiale')) {
      origin = 'Italy';
    }
    
    return {
      id: name.toLowerCase().replace(/\s+/g, '-'),
      name: name,
      productImage: productImagePath,
      usageImage: usageImagePath,
      description: `Premium ${category.toLowerCase()} with exceptional quality and durability. Perfect for modern and traditional applications.`,
      origin: origin,
      rating: 4.5 + (index % 5) * 0.1,
      features: ['Premium Quality', 'Durable', 'Elegant Finish', 'Versatile'],
      category: category,
    };
  });
};

